<template>
  <v-autocomplete
    v-model="input_value"
    :items="rows"
    :loading="isLoading"
    :search-input.sync="search"
    item-text="private_label"
    item-value="id"
    :label="$t('admin.app.elements')"
    outlined
    rounded
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.private_label" />
        <v-list-item-subtitle v-text="item.content_type.label" />
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      // Array: las reglas del leaderboard eligen varios destinos (multiple).
      type: [Number, String, Array],
      default: 0,
    },
    filterName: {
      type: String,
      default: '',
    },
    exclude: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Elementos',
    },
  },
  data: () => ({
    search: null,
  }),
  computed: {
    ...mapState({
      items: (state) => state.constants.run_time.content_elements,
      isLoading: (state) => state.constants.is_loading.content_elements,
    }),
    excludeAbles() {
      return this.exclude.filter((row) => row != this.value)
    },
    rows() {
      if (this.filterName) {
        return this.items.filter((row) => {
          return this.filterName == row.content_type.name
        })
      }
      if (this.excludeAbles.length > 0) {
        return this.items.filter((row) => !this.excludeAbles.includes(row.id))
      }
      return this.items
    },
    input_value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  // watch: {
  //   search() {
  //     if (this.items.length > 0) return
  //     this.loadRows()
  //   },
  // },
  mounted() {
    if (this.items.length > 0) return
    this.loadRows()
  },
  methods: {
    loadRows() {
      this.$store.dispatch('constants/loadContentElements')
    },
  },
}
</script>

<style></style>
